exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-enter-active{transition:all .4s ease}.flip-leave-active{display:none}.flip-enter,.flip-leave{transform:rotateY(180deg);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bab5f6d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/attached/components/cardFileUpload.vue
// module id = 1244
// module chunks = 2